import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { num: "1", title: "Send a request", body: "Fill out the order form with your item, size, yarn colour and date needed — inspiration photos welcome." },
  { num: "2", title: "Confirm with a deposit", body: "I'll reply with your quote. A 50% deposit by e-transfer, Square or PayPal secures your spot in the order queue." },
  { num: "3", title: "Handcrafting begins", body: "Most pieces take a week to a week and a half. Throw blankets need a little extra time." },
  { num: "4", title: "Yours to keep", body: "Pickup in the Guelph–Waterloo area, $5 flat local delivery, or shipping anywhere in Canada & the US." },
];

export default function Process() {
  return (
    <section id="how-it-works" data-testid="process-section" className="py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal>
          <Eyebrow testId="process-eyebrow">How Ordering Works</Eyebrow>
          <h2 className="mt-4 max-w-xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-[#2C2520] sm:text-4xl lg:text-5xl">
            From your idea to <span className="italic text-[#A35C45]">your hands.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-[#E6DFD5] bg-[#E6DFD5] sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1} className="h-full">
              <div data-testid={`process-step-${s.num}`} className="group flex h-full flex-col bg-[#FDFBF7] p-6 transition-colors duration-500 hover:bg-[#FAF7F2] sm:p-8">
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-[#C88A75]/50 font-serif text-xl font-semibold italic text-[#A35C45] transition-colors duration-500 group-hover:bg-[#A35C45] group-hover:text-[#FDFBF7]">
                  {s.num}
                </span>
                <h3 className="mt-6 font-serif text-xl font-medium tracking-tight text-[#2C2520]">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#6E6259]">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p data-testid="process-note-payment" className="mt-8 text-center font-mono text-xs uppercase tracking-[0.2em] text-[#8C7A6B]">
            No online checkout — payment details are arranged personally, by e-transfer, Square or PayPal
          </p>
        </Reveal>
      </div>
    </section>
  );
}
